module.exports = __webpack_public_path__ + "static/media/calculator-no-style.f4070b45.png";